export const formatGengoYear = (y: number) => {
  if (y === 1) return '元';
  return y;
};
